

import fetcher from "../../services/fetcher";
import { ONLINE_SALES } from '../../services/apis';

class OnlineSalesProcessProvider {

  static async getAllOnlineSalesPartyAvailability(payload = {}) {
    const res = await fetcher.post(ONLINE_SALES.API_GET_ONLINE_SALES_PARTY_AVAILABILITY_LIST, payload);
    return res;
  }
}


export default OnlineSalesProcessProvider
